/* global document */

import ReactDOM from 'react-dom';

// eslint-disable-next-line import/no-cycle
import Widget from './jordanEventPricing/JordanEventPricing';

const JordanEventPricing = (props) =>
  ReactDOM.createPortal(
    <>
      <Widget slug={props.slug} />
    </>,
    document.getElementById('c7-event-pricing-jv')
  );

export default JordanEventPricing;
